// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import MatchHeightController from "./match_height_controller"
application.register("match-height", MatchHeightController)

import RubyUi__CalendarController from "./ruby_ui/calendar_controller"
application.register("ruby-ui--calendar", RubyUi__CalendarController)

import RubyUi__CalendarInputController from "./ruby_ui/calendar_input_controller"
application.register("ruby-ui--calendar-input", RubyUi__CalendarInputController)

import RubyUi__CheckboxGroupController from "./ruby_ui/checkbox_group_controller"
application.register("ruby-ui--checkbox-group", RubyUi__CheckboxGroupController)

import RubyUi__DialogController from "./ruby_ui/dialog_controller"
application.register("ruby-ui--dialog", RubyUi__DialogController)

import RubyUi__FormFieldController from "./ruby_ui/form_field_controller"
application.register("ruby-ui--form-field", RubyUi__FormFieldController)

import RubyUi__MaskedInputController from "./ruby_ui/masked_input_controller"
application.register("ruby-ui--masked-input", RubyUi__MaskedInputController)

import RubyUi__PopoverController from "./ruby_ui/popover_controller"
application.register("ruby-ui--popover", RubyUi__PopoverController)

import RubyUi__SheetContentController from "./ruby_ui/sheet_content_controller"
application.register("ruby-ui--sheet-content", RubyUi__SheetContentController)

import RubyUi__SheetController from "./ruby_ui/sheet_controller"
application.register("ruby-ui--sheet", RubyUi__SheetController)

import RubyUi__SidebarController from "./ruby_ui/sidebar_controller"
application.register("ruby-ui--sidebar", RubyUi__SidebarController)

import RubyUi__ToastController from "./ruby_ui/toast_controller"
application.register("ruby-ui--toast", RubyUi__ToastController)

import RubyUi__ToasterController from "./ruby_ui/toaster_controller"
application.register("ruby-ui--toaster", RubyUi__ToasterController)

import RubyUi__TooltipController from "./ruby_ui/tooltip_controller"
application.register("ruby-ui--tooltip", RubyUi__TooltipController)

import TransactionFormController from "./transaction_form_controller"
application.register("transaction-form", TransactionFormController)
